import {DateTime} from "luxon";

export default function utcToLocal(isoString, format='yyyy-LL-dd ttt') {

    return isoString ? DateTime.fromISO(isoString, { zone: "UTC"}).toLocal().toFormat(format) : '';
};